 //const baseUrl = 'http://cogzb.com/'   // 测试环境地址cogzb.com
const baseUrl = 'https://dev-cogzb-api.scszsj.com/' // 产线地址 
//const baseUrl = 'https://cogzb-api.scszsj.com/' // 产线地址 

// const baseUrl = process.env.VUE_APP_API_URL; // 使用环境变量

export {
    baseUrl
}

